import {
    Component, ElementRef,
    forwardRef,
    Input, ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MODAL_EDITOR_TOKEN, ModalEditorBase } from '../../../classes/modal-editor-base';
import { dateToNgbDate } from 'apps/account/src/account-shared/classes/custom-ngb-adapter';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateUtils } from 'shared';
import { formatDate } from '@angular/common';

@Component({
    selector: 'ft-datepicker-editor',
    templateUrl: './datepicker-editor.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => DatePickerEditor)
        },
        {
            provide: MODAL_EDITOR_TOKEN,
            useExisting: DatePickerEditor
        }
    ]
})
export class DatePickerEditor extends ModalEditorBase {
    @Input() placeholder = 'Select date';
    @ViewChild('inputElement', { static: false }) inputElement: ElementRef;

    constructor() {
        super();
    }

    mapValue(value: any): any {
        return dateToNgbDate(value);
    }

    onModelChange(value: NgbDate) {
        super.onModelChange(formatDate(DateUtils.ngbDateToDate(value), 'MMM d, yyyy', 'en-US'));
    }
}


